module.exports = __webpack_public_path__ + "img/7.659ce59e.jpg";